import React, { FC } from 'react'
import { LabelComponent, PageBlockComponent, UIPlacement, i18n } from 'LibNeo'
import { StyledDrawer } from 'LibNeo/components/Basic/Drawer/styled'

const DEFAULT_DRAWER_WIDTH = '40%'
const DEFAULT_PLACEMENT_DRAWER = 'right'

export interface DrawerProps {
	title?: string | JSX.Element
	titleCode?: string
	visible: boolean
	closable: boolean
	onClose: (e?: any) => void
	placement?: UIPlacement
	className?: string
	width?: string | number // sting for '40%', number for 240 -> transformer antd to '240px'
}

export const DrawerComponent: FC<DrawerProps> = ({
	title,
	titleCode,
	visible,
	closable,
	onClose,
	children,
	placement = DEFAULT_PLACEMENT_DRAWER,
	width,
	className,
}) => {
	return (
		<StyledDrawer
			className={className}
			title={typeof title === 'string' ? i18n(title) : title || i18n(titleCode)}
			width={width || DEFAULT_DRAWER_WIDTH}
			onClose={onClose}
			visible={visible}
			closable={closable}
			destroyOnClose
			// @ts-ignore
			placement={placement}
		>
			{children || (
				<PageBlockComponent centered>
					<LabelComponent title="Данные не найдены" />
				</PageBlockComponent>
			)}
		</StyledDrawer>
	)
}
